export default __webpack_public_path__ + "static/media/org_designation.e0fb66a6.svg";